// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_krV","cls2":"UserCard-cls2_Sv8 UserCard-cls1_krV"};